'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Paragraph = require('@narvar/nth-bit-paragraph');
var SharingTruckIcon = require('@narvar/nth-bit-icon-sharing-truck');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthHookTheme = require('@narvar/nth-hook-theme');
var GiftTrackingMessage_module = require('./GiftTrackingMessage.module.css.js');
var clsx = require('clsx');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Paragraph__default = /*#__PURE__*/_interopDefaultLegacy(Paragraph);
var SharingTruckIcon__default = /*#__PURE__*/_interopDefaultLegacy(SharingTruckIcon);

const GiftTrackingMessage = ({
  featureName,
  isLandscape
}) => {
  const {
    giftTrackingRecipientMessage
  } = nthHookTranslations.useTranslations();
  const {
    bodytextDefaultNone
  } = nthHookTheme.useTheme();
  const containerClasses = clsx.clsx(isLandscape && GiftTrackingMessage_module["default"].containerLandscape, !isLandscape && GiftTrackingMessage_module["default"].containerPortrait);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: containerClasses
  }, /*#__PURE__*/React__default["default"].createElement(SharingTruckIcon__default["default"], {
    featureName: featureName
  }), /*#__PURE__*/React__default["default"].createElement(Paragraph__default["default"], {
    featureName: featureName,
    disableTheme: true,
    containerCustomStyle: {
      ...bodytextDefaultNone,
      fontWeight: 'bold',
      margin: 0,
      padding: isLandscape ? '0 0 0 1rem' : '1rem 0 0 0'
    }
  }, giftTrackingRecipientMessage));
};
var GiftTrackingMessage$1 = nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(GiftTrackingMessage, {
  themeTokens: ['bodytextDefaultNone']
}), {
  translationKeys: ['giftTrackingRecipientMessage']
});

exports["default"] = GiftTrackingMessage$1;
